import React from 'react';
import { MdKeyboardArrowDown } from 'react-icons/md';

const TableCustomHeader = (props) => {
    return (
        <th style={(props.style) && props.style} width={props.width?props.width:'auto'} className={'custom-table-header'} key={props.itemkey} onClick={() => props.updateDirection(props.itemkey)} >
            <span>{props.columnMeta.label}
                {(props.order.order_by === props.columnMeta.name) ?
                    <MdKeyboardArrowDown
                        style={{
                            fontSize:24,
                            padding: 0,
                            transform: props.order.direction === 'desc'
                                ? 'rotate(0deg)'
                                : 'rotate(-180deg)',
                            transitionDuration: '0.3s',
                            transitionProperty: 'transform',
                        }}
                    /> : ''}</span>
        </th>
    );
}

export default TableCustomHeader;